import { flow } from 'fp-ts/function';
import { createAction, DateService, DateTimeService } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { RESTRICTIONS_FILTER_CHANGED } from '../actionTypes';
import { dispatchWithFilterAppliedTracking } from './analyticsTracking';

export const changeFilterValues = (filterValues: $TSFixMe, scope: string) =>
    createAction(RESTRICTIONS_FILTER_CHANGED, filterValues, { scope });

export const submitFilterValues =
    ({ startDate, endDate }: $TSFixMe, serviceId: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const state = getState();
        const localizationInfo = getCurrentDateTimeLocalizationInfo(state);
        const timezone = getCurrentEnterpriseIanaTimeZoneIdentifier(state);

        const localizedDateToDateTime = flow(
            // @ts-expect-error $TSFixMeError: Argument of type 'unknown' is not assignable to parameter of type 'string'.
            (localizedDate) => DateService.fromString(localizedDate, localizationInfo, timezone),
            DateTimeService.fromDate
        );

        const startDateTime = localizedDateToDateTime(startDate);
        const endDateTime = localizedDateToDateTime(endDate);

        const filterValues = {
            dateRange: {
                startDateTime,
                endDateTime,
            },
        };

        dispatch(dispatchWithFilterAppliedTracking(filterValues)(changeFilterValues(filterValues, serviceId)));
    };
